import Loading from "components/Loading"
import React, { useState, useEffect } from "react"
import { Redirect } from "react-router-dom"
import { useStore } from "store"
import { useHistory } from "react-router"

const SigninWithToken = props => {
  const { signinWithToken, loadNewAgreements, token } = props

  const [isPending, setIsPending] = useState(true)
  const [failed, setFailed] = useState(false)

  const [newAgreements] = useStore("newAgreements")
  const history = useHistory()

  useEffect(() => {
    const signin = async () => {
      try {
        const data = await signinWithToken({
          token,
          deviceId: window.localStorage.getItem("deviceUuid")
        })
        if (data.next_step.toLowerCase() === "finalize") {
          await loadNewAgreements()
        } else {
          history.push(`/`, {
            "next-step": "security-code",
            token: data.next_url.split("signins/")[1].split("/security")[0]
          })
        }
        setIsPending(false)
      } catch (error) {
        setFailed(true)
        setIsPending(false)
      }
    }
    signin()
  }, [loadNewAgreements, signinWithToken, token, history])

  if (isPending) {
    return <Loading />
  }
  if (failed) {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: {
            error: true,
            message: "Invalid token - Sign-in using your email."
          }
        }}
      />
    )
  }

  if (newAgreements.length > 0) {
    return <Redirect to="/agreements" />
  }
  return <Redirect to={props.path || "/"} />
}

export default SigninWithToken
